module.exports = __webpack_public_path__ + "static/img/honor-people.375cd165.png";